import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import HomeNewBooks from '@/components/ui/home-new-books/HomeNewBooks';
import HomePopularBooks from '@/components/ui/home-popular-books/HomePopularBooks';
import HomeSearchBlock from '@/components/ui/home-search-block/HomeSearchBlock';
import HomeInfoBlock from '@/components/ui/home-info-block/HomeInfoBlock';
import HomeAdvertisingSlider from '@/components/ui/home-advertising-slider/HomeAdvertisingSlider';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { IAdvertisingBlock } from '@/interfaces/advertisingBlock.interface';
import HomeBooksSlider from '@/components/ui/home-books-slider/HomeBooksSlider';
import { IPopularBooks } from '@/interfaces/popularBooks.interface';
import { ICollections } from '@/interfaces/collections.interface';
import HomeCollectionList from '@/components/ui/home-collection-list/HomeCollectionList';

interface IHomePage extends IWidgetsSideBar {
  popularBooks: IPopularBooks;
  newBooks: IBookPage;
  oneNewBook: IBooksPageData;
  advertisingBlock: IAdvertisingBlock;
  freeBooks: IBookPage;
  collections: ICollections;
}

const Home: FC<IHomePage> = ({ popularBooks, newBooks, oneNewBook, todayWidget, popularBooksWidget, advertisingBlock, freeBooks, collections }) => {
  //seo block
  const SEO_TITLE = 'Электронная библиотека - скачать книги бесплатно, журналы, словари любых авторов';
  const SEO_DESCRIPTION = 'Коллекция бесплатных книг в электронном варианте :: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} canonicalHref="/">
      {freeBooks && freeBooks.data?.length > 0 && <HomeBooksSlider books={freeBooks.data} />}

      {collections && collections.data.length > 0 && <HomeCollectionList data={collections} />}
      <HomeNewBooks oneNewBook={oneNewBook} newBooks={newBooks} />
      <HomePopularBooks popularBooks={popularBooks} />
      {advertisingBlock && advertisingBlock.length > 0 && <HomeAdvertisingSlider books={advertisingBlock} />}
      <HomeSearchBlock />
      <HomeInfoBlock />
    </Layout>
  );
};

export default Home;
